import { oc } from '@orpc/contract';
import { addWorkOptionInputSchema, listCostItemsOutputSchema } from '../schemas/costs.schemas.js';
/**
 * One of the prototype's five work buttons (PP §7.3): the body and battery options are priced as a rate
 * on the **current appraisal**, the oil service as the template's flat fee. Each option may exist only
 * once per record — "a checkbox creates an estimate item once".
 */
export const addCostWorkOptionContract = oc
    .route({
    method: 'POST',
    path: '/costs/work-option',
    tags: ['Costs'],
    summary: 'Add one of the standard work estimates',
})
    .input(addWorkOptionInputSchema)
    .output(listCostItemsOutputSchema);
//# sourceMappingURL=add-cost-work-option.contract.js.map